<template>
  <v-data-table :headers="headers" :items="docs" :pagination.sync="pagination" hide-actions class="elevation-1">
    <template slot="headers" slot-scope="props">
      <tr>
        <th class="primary" v-for="header in props.headers" :class="`text-xs-${header.align}`" :key="header.text">
          {{ header.text }}
          <v-icon small v-show="pagination.sortBy != header.text" color="primaryText">arrow_upward</v-icon>
          <v-icon small v-show="pagination.sortBy == header.text && pagination.descending == false" color="primaryText">arrow_upward</v-icon>
          <v-icon small v-show="pagination.sortBy == header.text && pagination.descending == true" color="primaryText">arrow_downward</v-icon>
        </th>
      </tr>
    </template>
    <template slot="items" slot-scope="props">
      <td class="center primary">
        <a class="primaryText--text" href="#" @click.prevent="openDoc(props.item)"
          >{{ props.item.fileName ? props.item.fileName : props.item.key }}</a>
      </td>
      <td v-if="actionVisible" class="text-xs-center primary">
        <v-btn icon class="mx-0" @click="deleteItem(props.item)">
          <v-icon color="error">delete</v-icon>
        </v-btn>
      </td>
    </template>
    <template slot="no-data">
      <tr>
        <td class="text-xs-right primary">NO DOCS</td>
        <td class="text-xs-right primary"></td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { Api } from '@/services/Api'
import { mapGetters } from 'vuex'

export default {
  props: {
    docs: {
      type: Array,
      default: function() {
        return []
      }
    },
    docsHeader: {
      type: Array,
      default: function() {
        return []
      }
    },
    actionVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [{
        text: 'DOCUMENTS',
        align: 'left',
        sortable: false,
        value: 'name'
      }],
      pagination: {
        sortBy: 'Equipment',
        rowsPerPage: 500
      }
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId'])
  },
  mounted() {
    this.header = [...this.docsHeader]
    if (this.actionVisible) {
      this.headers.push({
        text: 'ACTIONS',
        align: 'center',
        value: 'name',
        sortable: false
      })
    }
  },
  methods: {
    openDoc(item) {
      // Re-emit to parent so it can refresh the presigned URL before opening,
      // preventing AccessDenied errors when the tab has been open for >1 hour.
      this.$emit('open-doc', item)
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    deleteItem(item) {
      const index = this.docs.indexOf(item)
      let newFiles = ''
      if (this.docs.length > 0) {
        confirm('Are you sure you want to delete this item?') && this.docs.splice(index, 1)
        // Use item.key (stable S3 key) not item.name (pre-signed URL that changes)
        newFiles = this.docs.map(item => item.key || item.name).join()
      }
      if (newFiles == '') {
        newFiles = 'null'
      }
      newFiles = Buffer.from(newFiles).toString('base64')
      Api()
        .delete(`/api/v1.0/doclink/${this.getSelectedPlantId}/${newFiles}`)
        .then(res => {
          console.log(res)
        })
        .catch(err => console.log(err, 'Error in deleting the file'))
    }
  }
}
</script>
